/**
 * expenseCorrectionAccess — geteilte Zugriffslogik für das Expense-Storno-Feature
 * ("Ausgabe stornieren/korrigieren").
 *
 * Single source of truth dafür, WER den Korrektur-Assistenten sehen und benutzen
 * darf. 1:1-Muster zu `datevExportAccess.ts` — wird analog von der Route-
 * Registrierung, dem „Korrigieren"-Button (`ExpensesPage`) und dem
 * `ExpenseCorrectionModal`-Gate gemeinsam genutzt (kein Copy-Paste der Flag-/
 * Allowlist-Bedingung).
 *
 * Kein Premium-Term (wie DATEV-Export) — sobald das Flag aktiv ist, gilt das
 * Feature für ALLE eingeloggten Nutzer gleichermaßen.
 *
 * Zwei Freischalt-Pfade (fail-closed — Default ist KEIN Zugriff):
 *   1. Beta-Allowlist: explizit gelistete Test-Account-UIDs sehen das Feature
 *      LIVE, unabhängig vom Env-Flag (kontrollierte Erprobung).
 *   2. Allgemeine Freigabe: `REACT_APP_EXPENSE_CORRECTION_ENABLED='true'` — ohne
 *      weitere Bedingung.
 *
 * @module expenseCorrectionAccess
 */

/**
 * Beta-Erprobung Expense-Storno — entfernen/erweitern, wenn allgemein freigegeben.
 *
 * Nur diese UIDs erhalten Zugriff unabhängig vom Env-Flag. HARTKODIERT für die
 * kontrollierte Live-Erprobung; vor allgemeiner Freigabe (Flag = 'true' für alle
 * Nutzer) wieder leeren.
 */
export const EXPENSE_CORRECTION_BETA_UIDS: readonly string[] = ['b3DRR1Cj63cRjdJg5VCEUpBL7hk1'];

/**
 * Allgemeines Feature-Flag. Fail-closed: nur bei explizitem `'true'` aktiv.
 * Modul-Konstante, einmalig beim Bundle-Load ausgewertet.
 */
export const EXPENSE_CORRECTION_FLAG: boolean =
  process.env.REACT_APP_EXPENSE_CORRECTION_ENABLED === 'true';

/**
 * Entscheidet fail-closed, ob ein Nutzer den Expense-Storno-Assistenten
 * sehen/benutzen darf.
 *
 * Kein Premium-Term: bei allgemeiner Freigabe (Flag aktiv) gilt das Feature für
 * ALLE eingeloggten Nutzer, nicht nur Premium.
 *
 * @param uid - Firebase-Auth-UID des aktuellen Nutzers (oder null/undefined,
 *              solange noch nicht eingeloggt).
 * @returns `true`, wenn die UID auf der Beta-Allowlist steht ODER das
 *          allgemeine Flag aktiv ist. Sonst `false`.
 */
export function canUseExpenseCorrection(uid: string | null | undefined): boolean {
  if (uid && EXPENSE_CORRECTION_BETA_UIDS.includes(uid)) {
    return true;
  }
  return EXPENSE_CORRECTION_FLAG;
}
